import * as Popover from '@radix-ui/react-popover'
import { NodeViewWrapper } from '@tiptap/react'
import { ChevronDown, CircleMinus, CirclePlus } from 'lucide-react'
import { Button } from '#app/components/ui/button.js'
import { Input } from '#app/components/ui/input.js'
import { icons } from './icon'

// @ts-ignore
export const Component = props => {
	const editable = props.editor.isEditable
	const editor = props.editor

	if (editable) {
		const handleLinkChange = (value: string) => {
			props.updateAttributes({
				link: value,
			})
		}

		const handleIconChange = (value: string) => {
			props.updateAttributes({
				icon: value,
			})
		}

		const addIcon = () => {
			if (editor) {
				const nodeEndPos = props.getPos() + props.node.nodeSize
				editor
					.chain()
					.focus()
					.insertContentAt(nodeEndPos, '<a data-type="linkIcon"></a>')
					.blur()
					.run()
			}
		}

		const removeIcon = () => {
			if (editor) {
				const currentPos = props.getPos()

				editor
					.chain()
					.focus()
					.deleteRange({
						from: currentPos,
						to: currentPos + props.node.nodeSize,
					})
					.blur()
					.run()
			}
		}

		return (
			<NodeViewWrapper className="[&>*]:flex">
				<Popover.Root>
					<Popover.Trigger className="h-6 w-6">
						<img
							src={props.node.attrs.icon}
							alt="some social icons"
							className="transition-sm !rounded-none hover:opacity-60"
						/>
					</Popover.Trigger>
					<Popover.Portal>
						<Popover.Content
							className="custom-popover z-50 flex items-center gap-2 rounded-xl border border-border bg-white p-2 shadow-sm"
							sideOffset={8}
							onOpenAutoFocus={e => e.preventDefault()}
						>
							<div className="flex flex-col space-y-2">
								<div className="relative">
									<select
										name="icon"
										className="h-[32px] w-full appearance-none rounded-[10px] border border-border px-2 outline-none hover:outline-none active:outline-none"
										value={props.node.attrs.icon}
										onChange={e => handleIconChange(e.currentTarget.value)}
									>
										{Object.entries(icons).map(([value, name]) => (
											<option key={value} value={name}>
												{value}
											</option>
										))}
									</select>
									<ChevronDown
										className="pointer-events-none absolute inset-y-1 right-1.5"
										width={16}
									/>
								</div>
								<Input
									type="url"
									placeholder="https://"
									variant="s"
									value={props.node.attrs.link}
									icon="Link2"
									onChange={e => handleLinkChange(e.currentTarget.value)}
								/>
								<div className="flex">
									<Button
										onClick={removeIcon}
										data-tooltip="Remove icon"
										data-tooltip-direction="up"
										className="flex h-[32px] w-[32px] items-center justify-center	 rounded-lg rounded-r-none border border-border bg-primary-foreground transition-all duration-150 ease-in-out group-hover:-rotate-6 group-hover:shadow-sm"
									>
										<CircleMinus width={16} className="shrink-0" />
									</Button>
									<Button
										onClick={addIcon}
										data-tooltip="Add icon"
										data-tooltip-direction="up"
										className="flex h-[32px] w-[32px] items-center justify-center rounded-lg rounded-l-none border border-l-0 border-border bg-primary-foreground transition-all duration-150 ease-in-out group-hover:-rotate-6 group-hover:shadow-sm"
									>
										<CirclePlus width={16} className="shrink-0" />
									</Button>
								</div>
							</div>
						</Popover.Content>
					</Popover.Portal>
				</Popover.Root>
			</NodeViewWrapper>
		)
	} else {
		const iconId = props.node.attrs.icon
		let icon = null

		switch (iconId) {
			case 'referralLink':
				icon = 'https://referralLink'
			case 'confirmationLink':
				icon = 'https://confirmationLink'
		}

		if (props.node.attrs.link || icon) {
			return (
				<NodeViewWrapper>
					<a
						href={props.node.attrs.link}
						target="_blank"
						rel="noreferrer"
						className="transition-sm inline-block h-6 w-6 hover:opacity-60"
					>
						<img
							src={props.node.attrs.icon}
							alt="some social icons"
							className="!rounded-none"
						/>
					</a>
				</NodeViewWrapper>
			)
		}
	}
}

export default Component
